import request from '@/utils/request'
const BASE_URL = '/pdd/waybills'

export default {
  waybill(data) {
    return request({
      url: BASE_URL + '/waybill',
      method: 'post',
      data
    })
  },
}